import { render } from "./clientnumber.vue?vue&type=template&id=47614133"
import script from "./clientnumber.vue?vue&type=script&lang=js"
export * from "./clientnumber.vue?vue&type=script&lang=js"

import "./clientnumber.vue?vue&type=style&index=0&id=47614133&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__